import React from 'react';
import { HelpCircle } from 'lucide-react';
import { goAdmin } from '../../lib/adminLinks';

// Contextual "?" that opens the Help Guide scrolled to one topic (Help Guide is the single source of truth).
export const HelpLink = ({ topic, label, testId, className = 'text-neutral-400' }) => (
  <button type="button" onClick={(e) => { e.stopPropagation(); goAdmin('help-guide', { topic }); }} title="Open help for this"
    className={`inline-flex items-center gap-1 text-xs hover:text-amber-700 transition-colors ${className}`} data-testid={testId || `help-link-${topic}`}>
    <HelpCircle className="w-4 h-4" />{label}
  </button>
);
